<div class="header">
	<app-ajax-loader [loaderId]="'CREATE_CHANGEOPP'"></app-ajax-loader>
	<app-ajax-loader [loaderId]="'UPDATE_CHANGEOPP'"></app-ajax-loader>
	<app-ajax-loader [loaderId]="'CREATE_ANALYTICSGRAPH'"></app-ajax-loader>
	<app-ajax-loader [loaderId]="'QUERY_CHANGEOPP'"></app-ajax-loader>
	<div class="header-logo-container" (click)="logoClickHandler()">
		<img [src]="headerLogo" />
		<div class="vertical-line"></div>
		<span>{{headerString}} - {{version}}</span>
	</div>
	<div class="float-left logo pl-0 postionRelative" style="right: 20%;">
		<span *ngIf="showUserDetails">
			<span class="pl-1 pr-2" style="font-size: 10px !important;	opacity: 0.3 !important;">|</span>
			User : {{userDetail.email}}
		</span>
	</div>
	<div class="header-icons float-right adminClass">
		<span *ngIf="userDetail?.role === 'admin'" class="cursorPointer">
			<span class="icon-caption dropdown dropdown-toggle" data-toggle="dropdown" (click)="onIconClick()">
				<img src="assets/images/admin-icon.svg" alt="">
				<div data-testid="admin_btn">Admin</div>
			</span>
			<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
				<li class="dropdown-item" (click)="onOpportunityAssign()">Assign Opportunity</li>
				<li class="dropdown-item" (click)="onOpportunityTranfer()" *ngIf="isBetaServer">Transfer Opportunity
				</li>
				<li class="dropdown-item" *ngIf="(inOppPage || simpleSizerDS.state.isSimpleSizer) && !showUserDetails" (click)="onViewAs()">View As</li>
				<li class="dropdown-item" (click)="onViewAsAdmin()" *ngIf="showUserDetails && inOppPage">View As Original</li>
				<li class="dropdown-item" (click)="nodeInformation()">Node Information</li>
			</ul>
		</span>
		<span *ngIf="userDetail?.role !== 'admin'" [ngClass]="(showUserDetails && inOppPage) ? 'cursorPointer' : ''" >
			<span class="icon-caption dropdown dropdown-toggle" data-toggle="dropdown" (mouseover)="onIconClick()">
				<img src="assets/images/user-icon.svg" alt="">
				<div>User</div>
			</span>
			<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
				<li class="dropdown-item" (click)="onViewAsAdmin()" *ngIf="showUserDetails && inOppPage">View As Original</li>
			</ul>
		</span>
	</div>
	<div class="header-icons float-right adminClass">
		<span  class="cursorPointer">
			<span class="icon-caption dropdown dropdown-toggle" data-toggle="dropdown" (click)="onIconClick()">
				<img src="assets/images/bug_report_1.svg" alt="">
				<div data-testid="admin_btn">Report Bug</div>
			</span> 
				<div id = "dropdown-report-bug-popup" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
					<div class="opp-details">
						<div>Opportunity ID:</div>
						<div>{{ opportunityId ? opportunityId:'N/A' }}</div>
					</div>
					<div class="opp-details">
						<div>Version:</div>
						<div>{{ version}}</div>
					</div>
					<div *ngIf="showTextArea && !isSubmitClicked">
						<form #feedbackForm="ngForm" (ngSubmit)="onSubmit(feedbackForm)" autocomplete="off" >
							<div class = "input-text">		
								<label for="response"  class="label-text">Please Enter Description:</label>
								<textarea class="text-area"  type="text" id="responseBugText" [(ngModel)]="responseBugText " rows = "5" cols="30"  name="responseBugText" required ></textarea>
								<button class="button" type="submit" [disabled]="feedbackForm.invalid"  >Submit</button>
							</div>
						</form>
					</div>
				</div>
			</span>	 
			<!-- Thank you message -->
			<span>
					<div *ngIf="isSubmitClicked" [ngStyle]="popupStyle" class="thank-you-message">
						This will now open your mail client. Please ensure the client is configured with your email ID and you send the email. Until the mail is sent, it will not reach the Engineering team. Thank you!
					</div>
			</span>		
	</div> 
	<div class="header-icons float-right">
		<a class="feedback cursorPointer"
			href="mailto:{{emailId}}?subject=Cohesity WST {{version}} Feedback (OppID: {{opportunityId ? opportunityId:'N/A'}})&body=Hi,%0A%09 Below are the list of feedback/issues faced while using Cohesity Sizing Tool.">
			<img src="assets/images/feedback-icon.svg">
			<div class="icon-caption">Feedback</div>
		</a>
	</div>
	<div class="header-icons float-right">
		<a target="_blank" class="cursorPointer" href="{{notesButtonLink}}">
			<img src="assets/images/release-Icon.svg">
			<div class="icon-caption">{{notesButtonText}}</div>
		</a>
	</div>
	<div *ngIf="simpleSizerDS.state.isSimpleSizer === false" class="header-icons float-right ">
		<a target="_blank" class="cursorPointer" href="https://partners.cohesity.com/learn/">
			<img src="assets/images/training-icon.svg">
			<div class="icon-caption">Training</div>
		</a>
	</div>
	<div class="header-icons float-right" *ngIf="userDetail?.role === 'admin'" (click)="analyticsPage()">
		<a class="cursorPointer">
			<img src="assets/images/analytics-icon.svg" alt="">
			<div class="icon-caption" data-testid="analytics_btn">Analytics</div>
		</a>
	</div>
	<!-- New WST UI button: Cohesity employees on full WST — hidden for Simple Sizer and IBM -->
	<div class="header-icons float-right header-new-ui-wrap" *ngIf="showNewWstUiButton && !simpleSizerDS.state.isSimpleSizer">
		<a class="new-ui-available-btn cursorPointer" [href]="newUiHref" target="_blank" rel="noopener noreferrer" title="Open the redesigned WST experience">
			<span class="new-ui-available-line new-ui-available-main">New WST UI</span>
			<span class="new-ui-available-line new-ui-available-sub">Try it&nbsp;<span class="new-ui-arrow" aria-hidden="true">→</span></span>
		</a>
	</div>
  <div class="header-icons float-right" *ngIf="simpleSizerDS.state.isSimpleSizer && opportunityId!==null" (click)="copyWSTIDToClipboard()">
    <a class="cursorPointer">
      <img src="assets/images/copy_light.svg" alt="">
      <div class="icon-caption">Copy WST ID</div>
    </a>
  </div>
</div>
